import React from 'react';

import SidebarTemplate from 'components/templates/SidebarTemplate';
import FormContents from 'components/atoms/Form/FormContents';
import TabControl from 'components/atoms/TabControl';
// import OrganizationInfoTable from 'components/organismos/organization/OrganizationInfoTable';
import OrganizationInputForm from 'components/organismos/organization/OrganizationInputForm';
import OrganizationManagerEditForm from 'components/organismos/organization/OrganizationManagerEditForm';

import BlockUI from 'components/molecules/BlockUi';
import { useOrganizationEdit } from './hooks';
import { Row, Col } from 'react-grid-system';
import FormPadding from 'components/atoms/Form/FormPadding';
import TargetApplicationForm from '../TargetApplicationForm';
import { css } from '@emotion/core';
import FormHeader from 'components/templates/FormHeader';

type SelectType = 'basic' | 'manager' | 'specialSalary' | 'approval'; 
const SelectType: { [key in SelectType]: SelectType } = {
  basic: 'basic',
  manager: 'manager',
  specialSalary: 'specialSalary',
  approval: 'approval'
};

const OrganizationEditPage: React.FC = () => {
  const {
    organizationDomain, setOrganizationDomain, managerList,
    setManagerList, seniorManagerList, setSeniorManagerList,
    historyList, setHistoryList, blocking
  } = useOrganizationEdit();
  const [selectType, setSelectType] = React.useState<SelectType>(SelectType.basic);
  const isAuthorizedFromPeople = process.env.REACT_APP_IS_AUTHORIZED_FROM_PEOPLE == 'true' || false;
  return (
    <SidebarTemplate>
      <BlockUI blocking={blocking}>
        <FormHeader title="組織編集"/>
        <FormContents customStyle={css({marginTop:'60px'})}>
          <FormPadding>
            <Row>
              <Col xl={7} lg={12}>
                <TabControl
                  items={[
                    {
                      value: SelectType.basic,
                      display: '基本情報',
                    },
                    {
                      value: SelectType.manager,
                      display: 'マネージャー管理情報',
                    },
                    // {
                    //   value: SelectType.specialSalary,
                    //   display: '特賃日割当情報',
                    // },
                    {
                      value: SelectType.approval,
                      display: '申請ルート',
                    },
                  ]}
                  setValue={setSelectType as (arg: string) => void}
                  currentValue={selectType}
                  isFixed={false}
                  customStyle={css({paddingLeft:'0'})}
                />
              </Col>
            </Row>
          </FormPadding>
          {
            selectType === SelectType.basic
            && (
              <>
                {/* <OrganizationInfoTable
                    organizationDomain={organizationDomain}
                  /> */}

                <OrganizationInputForm
                  initialOrganizationDomain={organizationDomain || undefined}
                  setInitialOrganizationDomain={setOrganizationDomain}
                  historyList={historyList}
                  setHistoryList={setHistoryList}
                  isEditMode={true}
                  isDisabledInfo={isAuthorizedFromPeople}
                />
              </>
            )
          }
          {
            selectType === SelectType.manager
            && (
              <OrganizationManagerEditForm
                managerList={managerList}
                seniorManagerList={seniorManagerList}
                setManagerList={setManagerList}
                setSeniorManagerList={setSeniorManagerList}
                isEditMode={true}
              />
            )
          }
          {
            selectType === SelectType.approval
            && (
              <TargetApplicationForm/>
            )
          }

          {/* {selectType === SelectType.specialSalary
              && (
              <OrganizationSpecialSalaryEditForm
                isEditMode={true}
              />
              )} */}
        </FormContents>
      </BlockUI>

    </SidebarTemplate>
  );
};

export default OrganizationEditPage;
